import React, { memo, useMemo } from 'react'

import { useHandler } from '@surglogs-app/hooks'
import {
  getStandaloneLoginRoute,
  redirectToExternalUrl,
  useLocationQuery,
  useLocationToVisitStorage,
} from '@surglogs-app/routing'
import { DefaultDialog } from '@surglogs-app/ui.dialog'

import { useAuthTranslation } from '../hooks/useAuthTranslation'

interface LoginInactivityProps {
  title?: string
  text?: string
  confirmButtonLabel?: string
}

export const LoginInactivity = memo(
  ({ confirmButtonLabel, text, title }: LoginInactivityProps) => {
    const { t } = useAuthTranslation()
    const { referrer } = useLocationQuery<{ referrer?: string }>()
    const { value: locationToVisit } = useLocationToVisitStorage()

    const onConfirm = useHandler(() => {
      if (referrer === 'external' && locationToVisit) {
        redirectToExternalUrl(locationToVisit?.href)

        return
      }

      redirectToExternalUrl(getStandaloneLoginRoute({ reason: 'inactivity' }), {
        replace: true,
      })
    })

    const variant = useMemo(() => {
      if (referrer === 'external') {
        return 'external' as const
      }

      return 'default' as const
    }, [referrer])

    return (
      <DefaultDialog
        {...{
          title: title ?? t(`inactivity.${variant}.title`),
          text: text ?? t(`inactivity.${variant}.text`),
          onConfirm,
          confirmButtonLabel:
            confirmButtonLabel ?? t(`inactivity.${variant}.buttonLabel`),
        }}
      />
    )
  },
)
